import differenceInDays from 'date-fns/differenceInDays';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

const validateFromDate = (dateFrom: string, dateTo: string) => {
  if (dateFrom) {
    if (
      differenceInDays(parse(dateFrom, 'yyyy-MM-dd', new Date()), new Date()) >=
      0
    ) {
      return dateFrom;
    }

    if (
      differenceInDays(parse(dateTo, 'yyyy-MM-dd', new Date()), new Date()) >= 0
    ) {
      return format(new Date(), 'yyyy-MM-dd');
    }
  }
  return null;
};

const validateToDate = (dateFrom, dateTo) => {
  if (!dateFrom) {
    return null;
  }

  if (dateTo) {
    if (
      differenceInDays(parse(dateTo, 'yyyy-MM-dd', new Date()), new Date()) >= 0
    ) {
      return dateTo;
    }
  }

  return null;
};

export default function validateFromStorage(dateFrom, dateTo) {
  const validatedFrom = validateFromDate(dateFrom, dateTo);
  const validatedTo = validateToDate(dateFrom, dateTo);

  return {
    dateFrom: validatedFrom,
    dateTo: validatedTo,
    isInThePast: validatedFrom === null && validatedTo === null,
  };
}
